import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  root: {
    paddingLeft: 8,
    paddingBottom: 0,
  },
  text: {
    color: theme.palette.primary.contrastText,
    fontWeight: 'bold',
    fontSize: 32,
  },
  image: {
    height: theme.spacing(5) * 122 / 100,
    width: theme.spacing(5),
  },
}));

